import { gql } from '@apollo/client';
import { PRICING_TARIFF_FIELDS } from '@/graphql/fragments/pricing_tariffs';

export const GET_TARIFFS = gql`
    ${PRICING_TARIFF_FIELDS}

    query GetTariffs($client_ids: [uuid!]!) {
        results: pricing_tariffs(
            where: {
                _or: [
                    { client_id: { _in: $client_ids } }
                    { client_id: { _is_null: true } }
                    { algo_type: { _eq: CARRIER_GLOBAL_DEFAULT } }
                    { algo_type: { _eq: SHIPPER_GLOBAL_DEFAULT } }
                ]
            }
            order_by: { created_at: desc }
        ) {
            ...PricingTariffFields
        }
    }
`;
